<template>
    <v-content>

        <v-layout justify-center align-center
                  style="min-height: 87vh"
                  :style="{ 'background-image': `url('` + require('../assets/bg-login.png') + `')`,
                            'background-size': 'cover',
                            'background-position': 'center'}">
            <v-flex xs11 sm9 md7 lg6>

                <v-card class="py-7" :class="{ 'px-12':$vuetify.breakpoint.smAndUp, 'px-5':$vuetify.breakpoint.xs }">

                    <v-layout justify-center align-center mb-3>
                        <v-flex shrink>
                            <img :src="require('../assets/logo.png')">
                        </v-flex>
                    </v-layout>

                    <v-layout column mb-10>
                        <v-flex cea-color titleHeader>
                            ลงชื่อเข้าใช้งาน
                        </v-flex>
                        <v-layout justify-center>
                            <v-flex xs8>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>
                        </v-layout>
                        <v-flex>
                            ระบบจัดการเนื้อหาเว็บไซต์
                        </v-flex>
                    </v-layout>

                    <v-text-field solo
                                  flat
                                  class="login-page"
                                  v-model="login.email"
                                  color="#FF4F23"
                                  style="width: 100%;"
                                  prepend-inner-icon="account_circle"
                                  placeholder="อีเมล หรือ ชื่อผู้ใช้งาน"
                                  v-on:keydown.enter="signIn"
                    ></v-text-field>

                    <v-text-field solo
                                  flat
                                  class="login-page"
                                  v-model="login.password"
                                  type="password"
                                  color="#FF4F23"
                                  style="width: 100%;"
                                  prepend-inner-icon="lock"
                                  placeholder="รหัสผ่าน"
                                  v-on:keydown.enter="signIn"
                    ></v-text-field>

                    <v-btn large color="#FF4F23"
                           class="white--text mb-3"
                           @click="signIn">
                        เข้าสู่ระบบ
                    </v-btn>

                    <v-layout>
                        <v-flex>
                            <img height="40px" width="40px"
                                 style="cursor: pointer;"
                                 :src="require('../assets/icon/google_circle-512.png')"
                                 @click="signInWithGoogle">
                        </v-flex>
                    </v-layout>

                </v-card>

            </v-flex>
        </v-layout>

        <Footer type="contact" style="min-height: 13vh"></Footer>

    </v-content>
</template>

<script>
    import Footer from "../components/Footer"
    import Service from '../services'
    import { domain } from "../services/Constants";
    import { mapActions, mapState } from 'vuex'
    import Swal from "sweetalert2";
    export default {
        name: "Login",
        components: {
            Footer
        },
        data: () => ({
            login: {
                email: null,
                password: null
            },
            http: domain

        }),
        computed: {

        },
        created() {

        },
        mounted() {
            if (this.$route.query.hasOwnProperty('result')) {
                let param = { token: this.$route.query.result }
                this.onUserLoginWithGoogle(param);
            }
        },
        methods: {
            ...mapActions('auth',['onUserLogIn','onUserLoginWithGoogle']),
            signIn() {
                if (this.login.email === null || this.login.password === null || this.login.email === "" || this.login.password === "") {
                  Swal.fire({
                    icon: 'warning',
                    text: 'กรุณากรอกชื่อผู้ใช้หรืออีเมล และพาสเวิร์ดให้ถูกต้อง',
                  })
                    // alert('กรุณากรอกชื่อผู้ใช้หรืออีเมล และพาสเวิร์ดให้ถูกต้อง');
                } else {
                    this.onUserLogIn(this.login);
                }
            },
            signInWithGoogle() {
                window.location = this.http + '/saml2/cea/login';
            }

        }
    }
</script>

<style scoped>

    .v-card.py-7 {
        border-radius: 20px;
        box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.25);
    }

    .v-divider.my-2 {
        border-color: #000;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    }

</style>
